import { Box, Grid, Select, Switch, Text, TextInput } from "@dehub/theme";
import { nameOptionsFilter } from "@dehub/theme";
import type { UseFormReturnType } from "@dehub/theme";
import { CaretDownIcon } from "@phosphor-icons/react";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import type { IGeneral } from "@/models/General";
import { renderName } from "@/utils/render-name";
import classes from "../../warehouse.module.css";
import type { IFormData } from "./warehouse-form";

type Props = {
  form: UseFormReturnType<IFormData>;
  isDetail?: boolean;
};

export function WarehouseContactSection({ form, isDetail }: Props) {
  const { t } = useTranslation("warehouse");
  const partnerStaffs = useSelector((state: { general: IGeneral }) => state.general.partnerStaffs);

  const staffOptions = useMemo(
    () =>
      (partnerStaffs as unknown as Array<{ id: string; firstName?: string; lastName?: string }> | undefined)?.map((c) => ({
        label: renderName(c),
        value: c.id,
      })) ?? [],
    [partnerStaffs],
  );

  return (
    <>
      <Grid.Col span={{ xs: 12, sm: 6, md: 4 }}>
        <Select
          searchable
          filter={nameOptionsFilter}
          data={staffOptions}
          label={t("form.responsible")}
          placeholder={t("form.responsible")}
          description={t("form.responsibleHint")}
          clearable
          nothingFoundMessage={t("form.nothingFound")}
          rightSection={<CaretDownIcon size={16} color="gray" />}
          readOnly={isDetail}
          {...form.getInputProps("warehouseUserId")}
        />
      </Grid.Col>
      <Grid.Col span={{ xs: 12, sm: 6, md: 4 }}>
        <TextInput label={t("form.phone")} placeholder={t("form.phone")} withAsterisk readOnly={isDetail} {...form.getInputProps("phone")} />
      </Grid.Col>
      <Grid.Col span={{ xs: 12, sm: 6, md: 4 }}>
        <Box className={classes.switchCard} mt={24}>
          <Text fz={14} fw={500}>{t("form.isDefault")}</Text>
          <Switch aria-label={t("form.isDefault")} disabled={isDetail} {...form.getInputProps("isDefault", { type: "checkbox" })} />
        </Box>
      </Grid.Col>
    </>
  );
}
